import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../../shared/models/component-messages/diveIN/step3';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeAnn_DIVER_G1 } from '../../models/TypeAnn_DIVER_G1';

@Component({
	selector: 'app-step3',
	templateUrl: './step3.component.html'
})
export class Step3Component implements OnInit {
	private LOG: LogService = new LogService(Step3Component);

	@Input() initial: TypeAnn_DIVER_G1;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() uid = '';

	public step3 = new Step3();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }

	ngOnInit(): void {
	}

	public getUid() {
		return this.uid;
	}

	getUidPrincipales(){
		return this.uid + '_SepSep_ChampsLibresTexte';
	}

	getUidTxtLibre(){
		return this.getUidPrincipales() + '_SepSep_ChampLibreGroup';
	}

	getUidIntLibre(){
		return this.getUidPrincipales() + '_SepSep_IntituleLibreGroup';
	}

}
